function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { postUser } from "../actions";
export var NumericConventionContext = /*#__PURE__*/React.createContext({});
export var NumericConventionProvider = function NumericConventionProvider(_ref) {
  var children = _ref.children;
  var dispatch = useDispatch();
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var authUser = useSelector(function (state) {
    return state.entities.users.byId[authUserId];
  });
  var postUserCall = useSelector(function (state) {
    return state.apiCalls.postUser["undefined"];
  }) || {};
  var _useCookies = useCookies(["pref-numericConvention"]),
    _useCookies2 = _slicedToArray(_useCookies, 3),
    cookies = _useCookies2[0],
    setCookie = _useCookies2[1],
    removeCookie = _useCookies2[2];
  var _useState = useState(authUser && authUser.numericConvention || cookies["pref-numericConvention"] || {
      id: 4,
      example: "1.234.567,89",
      thousandsGroupStyle: "thousand",
      thousandSeparator: ".",
      decimalSeparator: ","
    }),
    _useState2 = _slicedToArray(_useState, 2),
    numericConvention = _useState2[0],
    setNumericConvention = _useState2[1];
  useEffect(function () {
    removeCookie("pref-numericConvention");
    setCookie("pref-numericConvention", numericConvention);
    if (authUser && JSON.stringify(authUser.numericConvention) !== JSON.stringify(numericConvention)) {
      authUser.numericConventionId = numericConvention.id;
      dispatch(postUser(authUser));
    }
  }, [numericConvention]);
  useEffect(function () {
    if (!authUser) return;
    if (!authUser.numericConvention) {
      authUser.numericConventionId = 4;
      dispatch(postUser(authUser));
    } else {
      setNumericConvention(authUser.numericConvention);
    }
  }, [authUser]);
  return /*#__PURE__*/React.createElement(NumericConventionContext.Provider, {
    value: {
      numericConvention: numericConvention,
      setNumericConvention: setNumericConvention,
      loading: postUserCall.isFetching
    }
  }, children);
};
export var useNumericConventionContext = function useNumericConventionContext() {
  return useContext(NumericConventionContext);
};